/* fb-hero-slider.js — Crossfade-Slider fuer die fb-hero Section (Flaschenbauer.)
 * Kein Framework, keine Abhaengigkeiten. Wird nur geladen, wenn >1 Slide vorhanden ist.
 * Pausiert bei: Hover/Fokus, inaktivem Tab, ausserhalb des Viewports, prefers-reduced-motion.
 * Kein Layout-Thrashing: nur Klassenwechsel, keine Style-/Layout-Lesevorgaenge im Intervall.
 */
(function () {
  'use strict';
  if (window.__fbHeroSliderInit) return;
  window.__fbHeroSliderInit = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function FbHeroSlider(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-fb-hero-slide]'));
    if (this.slides.length < 2) return;

    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-fb-hero-dot]'));
    this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    this.interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && !REDUCED;
    this.pauseOnHover = root.getAttribute('data-pause-on-hover') === 'true';
    this.timer = null;
    this.paused = false;
    this.visible = true;
    this.locked = false; // Theme-Editor: Slide fixiert
    this.io = null;
    this.onVisibility = null;

    this.bind();
    this.observe();
    this.start();
  }

  FbHeroSlider.prototype.goTo = function (i, focusSlide) {
    var next = (i + this.slides.length) % this.slides.length;
    if (next === this.index) return;
    this.slides[this.index].classList.remove('is-active');
    this.slides[next].classList.add('is-active');
    if (this.dots.length) {
      this.dots[this.index].setAttribute('aria-current', 'false');
      this.dots[next].setAttribute('aria-current', 'true');
    }
    this.index = next;
    if (focusSlide) {
      var link = this.slides[next].querySelector('a, button');
      if (link) link.focus({ preventScroll: true });
    }
  };

  FbHeroSlider.prototype.next = function () { this.goTo(this.index + 1); };
  FbHeroSlider.prototype.prev = function () { this.goTo(this.index - 1); };

  FbHeroSlider.prototype.start = function () {
    this.stop();
    if (!this.autoplay || this.paused || !this.visible || this.locked) return;
    var self = this;
    this.timer = window.setInterval(function () { self.next(); }, this.interval);
  };

  FbHeroSlider.prototype.stop = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
  };

  FbHeroSlider.prototype.pause = function () { this.paused = true; this.stop(); };
  FbHeroSlider.prototype.resume = function () { this.paused = false; this.start(); };

  FbHeroSlider.prototype.bind = function () {
    var self = this;
    var root = this.root;

    var prevBtn = root.querySelector('[data-fb-hero-prev]');
    var nextBtn = root.querySelector('[data-fb-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { self.prev(); self.start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { self.next(); self.start(); });

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.goTo(parseInt(dot.getAttribute('data-fb-hero-dot'), 10));
        self.start();
      });
    });

    if (this.pauseOnHover) {
      root.addEventListener('mouseenter', function () { self.pause(); });
      root.addEventListener('mouseleave', function () { self.resume(); });
      root.addEventListener('focusin', function () { self.pause(); });
      root.addEventListener('focusout', function () {
        if (!root.contains(document.activeElement)) self.resume();
      });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.next(); self.start(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); self.prev(); self.start(); }
    });

    // Swipe (Touch)
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      x0 = e.changedTouches[0].clientX;
      y0 = e.changedTouches[0].clientY;
      self.pause();
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) self.next(); else self.prev();
      }
      x0 = null; y0 = null;
      self.resume();
    }, { passive: true });

    this.onVisibility = function () {
      if (document.hidden) self.stop(); else self.start();
    };
    document.addEventListener('visibilitychange', this.onVisibility);
  };

  FbHeroSlider.prototype.observe = function () {
    if (!('IntersectionObserver' in window)) return;
    var self = this;
    this.io = new IntersectionObserver(function (entries) {
      self.visible = entries[0].isIntersecting;
      self.start();
    }, { threshold: 0.2 });
    this.io.observe(this.root);
  };

  FbHeroSlider.prototype.destroy = function () {
    this.stop();
    if (this.io) { this.io.disconnect(); this.io = null; }
    if (this.onVisibility) {
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.onVisibility = null;
    }
  };

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fb-hero-slider]').forEach(function (root) {
      if (root.__fbHero) return;
      root.__fbHero = new FbHeroSlider(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // ---- Theme-Editor ----
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-fb-hero-slider]');
    if (root && root.__fbHero) { root.__fbHero.destroy(); root.__fbHero = null; }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-fb-hero-slider]');
    if (!root || !root.__fbHero) return;
    var slider = root.__fbHero;
    var i = slider.slides.indexOf(e.target);
    if (i > -1) slider.goTo(i);
    slider.locked = true;
    slider.stop();
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = e.target.closest('[data-fb-hero-slider]');
    if (!root || !root.__fbHero) return;
    root.__fbHero.locked = false;
    root.__fbHero.start();
  });
})();
